module.exports = __webpack_public_path__ + "img/立即購買.f0da49d0.svg";